export default __webpack_public_path__ + "static/media/brunch_dining.60dd1727.svg";